import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptHierarchy } from 'src/containers/ProjectDiagram/utils/data';
import {
  createModelConceptHierarchy,
  getModelConceptHierarchyKey,
} from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchy';
import { createModelConceptHierarchyLabel } from 'src/containers/ProjectDiagram/utils/modelConceptHierarchy/createModelConceptHierarchyLabel';
import { restoreDeletedHierarchy } from 'src/containers/ProjectDiagram/utils/restoreDeletedData';
import { RDFS_SUB_CLASS_OF_IRI } from 'src/templates/queries/iris';

export const addModelConceptHierarchy =
  ({
    fromIri,
    value = RDFS_SUB_CLASS_OF_IRI,
    toIri,
  }: {
    fromIri: string;
    toIri: string;
    value?: string;
  }) =>
  (model: Model) => {
    const key = getModelConceptHierarchyKey({ fromIri, value, toIri });
    const hierarchy = model.linkDataArray.find(
      (linkData) => isModelConceptHierarchy(linkData) && linkData.key === key
    );

    if (hierarchy) {
      return;
    }

    const newHierarchy = createModelConceptHierarchy({ fromIri, value, toIri });
    const newHierarchyLabel = createModelConceptHierarchyLabel({
      fromIri,
      value,
      toIri,
    });

    model.addLinkData(newHierarchy);
    model.addNodeData(newHierarchyLabel);

    restoreDeletedHierarchy(newHierarchy, newHierarchyLabel)(model);
  };
